import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useThemeSelectorStyles = (theme: Theme, selectedTheme: number) => {
  const invertedTheme = selectedTheme === 8;

  return {
    button: css({
      margin: 0,
      width: 48,

      '&.MuiButtonBase-root': {
        borderRadius: 0,

        '&.Mui-focusVisible, :hover': {
          backgroundColor: invertedTheme
            ? theme.palette.primary.light
            : theme.palette.primary.light,
        },
      },
    }),
    themeIcon: css({
      color: invertedTheme ? theme.palette.secondary.contrastText : theme.palette.primary.dark,
      fontSize: 24,
    }),
    drawerIcon: css({
      minWidth: 40,
    }),
  };
};
